<script>
    import {navigate} from 'svelte-routing';
    import {store} from '../stores.js';
    import {decode} from '../helpers.js';
    import storage from '../storage.js';

    const user = store('credential', 'getAuth'),
          user_loading = user.loading();
    const axis = store('axis', '', false);

    // credential
    let login = ($user.email ?? ''),
        password = '',
        error = false;

    const handlerLogin = async () => {
        if (login && password) {
            let result = await user.load({login, password});
        
            if (result.id > 0 ) {
                navigate('/dashboard');
            } else {
                error = true;
                setTimeout(() => error = false, 3000);
            }
        }
    }

    const handlerContinue = () => navigate('/dashboard');

    const handlerLogout = () => {
        navigate('/');
        user.remove();
        storage.clear();
    };

    if ($user.email && location.query.order) {
        setTimeout(async () => password = 'order', 350);
        setTimeout(async () => navigate('/dashboard' + location.search), 800);
    }

    if (location.query.credential) {
        let credential = JSON.parse(decode(location.query.credential));
    
        if (typeof credential === 'object') {
            storage.setItem('credential', JSON.stringify(credential));
            
            if (location.query.axis === 'true') {
                storage.setItem('axis', 'true');
            }
    
            if (location.query.axis === 'true' && credential.action) {
                switch (true) {
                    case credential.action === 'add': {
                        location.href = location.query.redirect ? location.query.redirect : `/create`;
                        break;
                    }
                    case credential.action === 'chat': {
                        location.href = location.query.redirect ? location.query.redirect : `/chat/${credential.nomer}`;
                        break;
                    }
                }
            } else {
                location.href = location.query.redirect ? location.query.redirect : `/dashboard`;
            }
        }
    } else if (location.query.auth) {
        // {"login": "alksily@...", "password": "xxx"}
        let auth = JSON.parse(decode(location.query.auth));
    
        if (typeof auth === 'object') {
            login = auth.login;
            password = auth.password;
    
            setTimeout(handlerLogin, 350);
        }
    } else {
        if (storage.getItem('axis')) {
            storage.removeItem('axis');
            location.reload();
        }
    }

    // сохранение параметров
    storage.setItem('params', JSON.stringify(location.query));
    
    const onKeyPress = (e) => {
        if (e.charCode === 13) handlerLogin();
    };
</script>

<div id="appCapsule">
    <div class="login-form mt-1">
        <div class="section">
            <img src="/img/android-chrome-512x512.png" alt="image" class="form-image">
        </div>
        
        {#if $user.email}
            <div class="section mt-5 mb-5">
                <div class="alert alert-outline-primary fade show text-center" role="alert">
                    <h4 class="alert-title">Вы уже вошли</h4>
                    
                    Если вы не <span>{$user.email}</span><br>
                    нажмите <a href="#" class="link" on:click={handlerLogout}>сюда</a>.
                </div>
                
                <div class="form-button-group">
                    <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerContinue}>
                        Продолжить
                    </button>
                </div>
            </div>
        {:else}
            <div class="section mt-5">
                <h4>Заполните форму для входа</h4>
            </div>
            <div class="section mt-1 mb-5">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input type="text" class="form-control" name="login" style="{error ? 'border: 1px solid red;' : ''}" bind:value={login} placeholder="Логин">
                    </div>
                </div>
                
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input type="password" class="form-control" name="password" style="{error ? 'border: 1px solid red;' : ''}" bind:value={password} on:keypress={onKeyPress} placeholder="Пароль" autocomplete="off">
                    </div>
                </div>
                
                <div class="form-button-group">
                    <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerLogin} disabled={$user_loading}>
                        {#if $user_loading}Входим{:else}Войти{/if}
                    </button>
                </div>
            </div>
        {/if}
    </div>
</div>
